import React, { useEffect } from "react";
import { useState } from "react";
import { API_URL } from "../../../constants/appConfig";
import myToast from "../../../components/toast";
import CarouselUpdate from "./carouselUpdateCard";
import { Box, Typography, Container } from "@mui/material";

const Index = () => {
  const [categories, setCategories] = useState([]);
  const [allCarouselItems, setAllCarouselItems] = useState([]);

  const getAllCategories = async () => {
    try {
      const response = await fetch(
        `${API_URL}/fullCategory/getAllFullCategory`
      );
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getHomePageCategories = async () => {
    try {
      const response = await fetch(
        `${API_URL}/homePageCategory/getAllHomePageCategory`
      );
      const data = await response.json();
      if (data.length === 0) {
        myToast({
          status: "error",
          message: "Ana sayfa kategorileri bulunamadı",
        });
        return;
      } else {
        setAllCarouselItems(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCategories();
    getHomePageCategories();
  }, []);
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 500 }}>
          Ana ekranda gözükecek olan rastgele kategorileri seçiniz.
        </Typography>
      </Box>

      <Box sx={{ 
        display: 'grid', 
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
          lg: 'repeat(4, 1fr)'
        },
        gap: 3
      }}>
        {allCarouselItems.map((item, index) => (
          <CarouselUpdate
            key={index}
            que={index}
            category={item}
            categories={categories}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Index;
